import React, { useEffect, useState } from 'react';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
const checkoutBasico = 'https://argentina.recursodigital.shop/cart/48784999153883:1';
const checkoutCompleto = 'https://argentina.recursodigital.shop/cart/48784999678171:1';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 34,
    seconds: 39
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (v: number) => v.toString().padStart(2, '0');
  return <section className="bg-[#0B0B12] py-20 px-5 relative overflow-hidden" data-id="element-110">
      <div className="blur-circle bg-brand-navy/40 -top-20 -right-20 opacity-40" data-id="element-111" />
      <div className="blur-circle bg-brand-blueDeep/30 -bottom-20 -left-20 opacity-30" data-id="element-112" />
      <div className="max-w-xl mx-auto relative z-10" data-id="element-113">
        <h2 className="text-3xl md:text-4xl font-black mb-12 leading-tight text-center text-white uppercase tracking-tight" data-id="element-114">
          🚨 EL PRECIO DE LANZAMIENTO TERMINA PRONTO
        </h2>

        <div className="text-center mb-12" data-id="element-115">
          <div className="flex items-end justify-center gap-3 mb-4" data-id="element-116">
            <div className="text-center" data-id="element-117">
              <span className="text-5xl md:text-7xl font-black gold-text-gradient drop-shadow-[0_0_15px_rgba(212,176,106,0.3)]" data-id="element-118">
                {fmt(timeLeft.hours)}
              </span>
              <p className="text-[10px] text-slate-500 font-black uppercase tracking-[0.3em] mt-2" data-id="element-119">
                HS
              </p>
            </div>
            <span className="text-4xl md:text-5xl font-black text-brand-gold/30 pb-3" data-id="element-120">
              :
            </span>
            <div className="text-center" data-id="element-121">
              <span className="text-5xl md:text-7xl font-black gold-text-gradient drop-shadow-[0_0_15px_rgba(212,176,106,0.3)]" data-id="element-122">
                {fmt(timeLeft.minutes)}
              </span>
              <p className="text-[10px] text-slate-500 font-black uppercase tracking-[0.3em] mt-2" data-id="element-123">
                MIN
              </p>
            </div>
            <span className="text-4xl md:text-5xl font-black text-brand-gold/30 pb-3" data-id="element-124">
              :
            </span>
            <div className="text-center" data-id="element-125">
              <span className="text-5xl md:text-7xl font-black gold-text-gradient drop-shadow-[0_0_15px_rgba(212,176,106,0.3)]" data-id="element-126">
                {fmt(timeLeft.seconds)}
              </span>
              <p className="text-[10px] text-slate-500 font-black uppercase tracking-[0.3em] mt-2" data-id="element-127">
                SEG
              </p>
            </div>
          </div>
          <p className="text-sm font-black uppercase tracking-widest text-[#DA7171]" data-id="element-128">
            Después sube y esta oferta desaparece.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10" data-id="element-129">
          <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-8 text-center flex flex-col transition-all hover:bg-white/10 shadow-2xl" data-id="element-130">
            <div className="text-4xl mb-4" data-id="element-131">📘</div>
            <h4 className="text-sm font-black text-white uppercase mb-2 leading-tight tracking-widest" data-id="element-132">
              MEGAPACK PELUQUERÍA LISTA™
            </h4>
            <p className="text-xs text-slate-500 mb-6 font-black uppercase tracking-widest" data-id="element-133">
              6 Tomos + 6 Bonos
            </p>
            <div className="mt-auto" data-id="element-134">
              <div className="text-3xl font-black text-white mb-6 tracking-tighter" data-id="element-135">
                $19.990 ARS
              </div>
              <a href={checkoutBasico} className="block w-full border-2 border-brand-gold/30 text-brand-gold font-black text-xs py-4 px-4 rounded-xl hover:bg-brand-gold hover:text-black transition-all text-center no-underline uppercase tracking-[0.2em]" data-id="element-136">
                QUIERO DEJAR DE IMPROVISAR
              </a>
            </div>
          </div>

          <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-md border-2 border-brand-gold rounded-2xl p-8 text-center flex flex-col transition-all hover:shadow-[0_0_30px_rgba(212,176,106,0.2)] hover:scale-[1.02] relative shadow-2xl" data-id="element-137">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-gold text-black text-[10px] font-black px-4 py-1 rounded-full uppercase tracking-[0.2em] whitespace-nowrap shadow-[0_0_15px_rgba(212,176,106,0.4)]" data-id="element-138">
              Recomendado
            </div>
            <div className="text-4xl mb-4" data-id="element-139">🏆</div>
            <h4 className="text-sm font-black gold-text-gradient uppercase mb-2 leading-tight tracking-widest" data-id="element-140">
              MEGAPACK + SISTEMA DE IMPLEMENTACIÓN⭐
            </h4>
            <p className="text-xs text-slate-400 mb-6 font-black uppercase tracking-widest" data-id="element-141">
              6 Tomos + 6 Bonos + Implementación
            </p>
            <div className="mt-auto" data-id="element-142">
              <div className="text-3xl font-black text-white mb-6 tracking-tighter" data-id="element-143">
                $27.990 ARS
              </div>
              <a href={checkoutCompleto} className="block w-full btn-premium font-black text-xs py-4 px-4 rounded-[20px] transition-all text-center no-underline uppercase tracking-[0.2em]" data-id="element-144">
                QUIERO EL SISTEMA COMPLETO
              </a>
            </div>
          </div>
        </div>

        <div className="text-center space-y-4 mt-12" data-id="element-145">
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-xs font-bold text-slate-400" data-id="element-146">
            <div className="flex items-center gap-2" data-id="element-147">
              <Lock size={16} className="text-brand-primary" data-id="element-148" />
              Pago 100% seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-149">
              <Zap size={16} className="text-brand-primary" data-id="element-150" />
              Acceso inmediato
            </div>
            <div className="flex items-center gap-2" data-id="element-151">
              <ShieldCheck size={16} className="text-brand-primary" data-id="element-152" />
              Garantía total
            </div>
          </div>
        </div>
      </div>
    </section>;
}